$(function() {
	if (easyXDM) {
		easySocket = new easyXDM.Socket({
		    onReady: function() {
		    	t();
		    }
		});

		t = function() {
			setTimeout(function() {
				if (!uploaderActive) {
					var obj = JSON.stringify({msg: 'render', height: $('body').height()});
		        	easySocket.postMessage(obj);
					t();
				}

			},1500);
		};
	}

});
